
import { createValidations } from '@/helpers/commons/validationHelper'
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import useValidate from '@vuelidate/core'
import Textarea from 'primevue/textarea'
import EditPreparedDatasetDialogValidationDescriptor from './EditPreparedDatasetDialogValidationDescriptor.json'

export default defineComponent({
    name: 'edit-prepared-dataset-dialog',
    components: { Dialog, Textarea },
    props: {
        visible: Boolean,
        dataset: Object
    },
    emits: ['save', 'cancel'],
    data() {
        return {
            newDataset: {} as any,
            v$: useValidate() as any,
            validationDescriptor: EditPreparedDatasetDialogValidationDescriptor
        }
    },
    validations() {
        return {
            newDataset: createValidations('newDataset', this.validationDescriptor.validations.configuration)
        }
    },
    updated() {
        if (this.dataset) {
            this.newDataset['label'] = this.dataset.label
            this.newDataset['name'] = this.dataset.name
            this.newDataset['description'] = this.dataset.description
        }
    },
    methods: {
        apply(): void {
            this.$emit('save', this.newDataset)
            this.clearForm()
        },
        cancel(): void {
            this.$emit('cancel')
            this.clearForm()
        },
        clearForm(): void {
            this.newDataset = {}
        }
    },
    computed: {
        saveButtonDisabled(): any {
            return this.v$.$invalid
        }
    }
})
